import InsightsSection from 'components/Enterprise/InsightsSection';
import React from 'react';

import { ContentWithImage, ImageType } from 'utils/types';

export interface InsightsContainerProps {
  content: {
    title: string;
    headline: string;
    listOfContentWithImages: ContentWithImage[];
    componentName: string;
    mobileImages: ImageType[];
    desktopImages: ImageType[];
  };
}

export const InsightsContainer: React.FC<InsightsContainerProps> = ({
  content,
}) => {
  if (!content) {
    return null;
  }

  const {
    title,
    headline,
    listOfContentWithImages,
    mobileImages: rawMobileImages,
    desktopImages: rawDesktopImages,
  } = content;

  return (
    <InsightsSection
      title={title}
      headline={headline}
      listOfContent={listOfContentWithImages}
      mobileImages={rawMobileImages}
      desktopImages={rawDesktopImages}
    />
  );
};

export default InsightsContainer;
